import React, { useEffect, useState, useMemo } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
// import Person from "@material-ui/icons/Person";
// import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance"; 
import { MantineReactTable } from "mantine-react-table";
const useStyles = makeStyles(styles);

export default function NotificationLog() {
  const [users, setUsers] = useState([]);
  const classes = useStyles();
  const columns = useMemo(() => [
    {
      header: "Player",
      accessorKey: "player",
      size: 5,
    },
    {
      header: "Sent",
      accessorKey: "sent",
      size: 10,
    },
    {
      header: "Sender",
      accessorKey: "sender",
      size: 10,
    },
    {
      header: "Subject",
      accessorKey: "subject",
      size: 10,
    },
  ]);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/notificationhistory`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log(res);
        setUsers(res.data.data);
      })

      .catch((err) => {
        console.log(err);
        if(err.response.data.message=="For security reasons, we locked your account.Please login to continue"){
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };



  // const handleDelete = async (userId, userType) => {
  //   const token = localStorage.getItem("token");
  //   console.log(userId);
  //   if (confirm("Are you sure you want to delete")) {
  //     await axios
  //       .delete(
  //         `https://cryptolotteryapi.dev.vinove.com/api/v1/admin/removeusers?userId=${userId}&userType=${userType}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Access-Control-Allow-Origin": "*",
  //           },
  //         },
  //         {
  //           userId,
  //           userType,
  //         }
  //       )
  //       .then((data) => {
  //         console.log(data);
  //         alert("You have successfully deleted!!");
  //         getData();
  //       })
  //       .catch(() => {
  //         //remove after working
  //         alert("Server Error");
  //       });
  //   } else {
  //     alert("Details are not deleted");
  //   }
  // };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Notification Log</h4>
          </CardHeader>
          <CardBody>
            <MantineReactTable
              columns={columns}
              enablePagination={false}
              enableFullScreenToggle={false}
              enableHiding={false}
              enableDensityToggle={false} 
              enableFilters={ false}
              enableColumnFilterModes
              initialState={{ showColumnFilters: true }}
              positionToolbarAlertBanner="bottom"
              data={users}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
